// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-roller_ldsRoller__BeY0- {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.styles-roller_ldsRoller__BeY0- div {
    animation: styles-roller_ldsRoller__BeY0- 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;
}
.styles-roller_ldsRoller__BeY0- div:after {
    content: ' ';
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--primary-color);
    margin: -4px 0 0 -4px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(1) {
    animation-delay: -0.036s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(1):after {
    top: 63px;
    left: 63px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(2) {
    animation-delay: -0.072s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(2):after {
    top: 68px;
    left: 56px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(3) {
    animation-delay: -0.108s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(3):after {
    top: 71px;
    left: 48px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(4) {
    animation-delay: -0.144s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(4):after {
    top: 72px;
    left: 40px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(5) {
    animation-delay: -0.18s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(5):after {
    top: 71px;
    left: 32px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(6) {
    animation-delay: -0.216s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(6):after {
    top: 68px;
    left: 24px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(7) {
    animation-delay: -0.252s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(7):after {
    top: 63px;
    left: 17px;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(8) {
    animation-delay: -0.288s;
}
.styles-roller_ldsRoller__BeY0- div:nth-child(8):after {
    top: 56px;
    left: 12px;
}
@keyframes styles-roller_ldsRoller__BeY0- {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/components/LoaderRoller/styles-roller.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,oFAA+D;IAC/D,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".ldsRoller {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n.ldsRoller div {\n    animation: ldsRoller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    transform-origin: 40px 40px;\n}\n.ldsRoller div:after {\n    content: ' ';\n    display: block;\n    position: absolute;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: var(--primary-color);\n    margin: -4px 0 0 -4px;\n}\n.ldsRoller div:nth-child(1) {\n    animation-delay: -0.036s;\n}\n.ldsRoller div:nth-child(1):after {\n    top: 63px;\n    left: 63px;\n}\n.ldsRoller div:nth-child(2) {\n    animation-delay: -0.072s;\n}\n.ldsRoller div:nth-child(2):after {\n    top: 68px;\n    left: 56px;\n}\n.ldsRoller div:nth-child(3) {\n    animation-delay: -0.108s;\n}\n.ldsRoller div:nth-child(3):after {\n    top: 71px;\n    left: 48px;\n}\n.ldsRoller div:nth-child(4) {\n    animation-delay: -0.144s;\n}\n.ldsRoller div:nth-child(4):after {\n    top: 72px;\n    left: 40px;\n}\n.ldsRoller div:nth-child(5) {\n    animation-delay: -0.18s;\n}\n.ldsRoller div:nth-child(5):after {\n    top: 71px;\n    left: 32px;\n}\n.ldsRoller div:nth-child(6) {\n    animation-delay: -0.216s;\n}\n.ldsRoller div:nth-child(6):after {\n    top: 68px;\n    left: 24px;\n}\n.ldsRoller div:nth-child(7) {\n    animation-delay: -0.252s;\n}\n.ldsRoller div:nth-child(7):after {\n    top: 63px;\n    left: 17px;\n}\n.ldsRoller div:nth-child(8) {\n    animation-delay: -0.288s;\n}\n.ldsRoller div:nth-child(8):after {\n    top: 56px;\n    left: 12px;\n}\n@keyframes ldsRoller {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ldsRoller": `styles-roller_ldsRoller__BeY0-`
};
export default ___CSS_LOADER_EXPORT___;
